define(function (require, exports, module) {
    'use strict';

    /**
     * @namespace
     */
    const dataTransferReader = {
        /**
         * @param {DataTransfer} dataTransfer
         * @param {string} type
         * @returns {boolean}
         */
        hasType(dataTransfer, type) {
            let hasType = false;

            // непонятная ошибка стреляет под Edge 18
            try {
                const types = dataTransfer.types;

                if (types) {
                    let i = types.length;

                    while (i--) {
                        if (types[i] === type) {
                            hasType = true;

                            break;
                        }
                    }
                }
            } catch (_) {}

            return hasType;
        },

        /**
         * @param {DataTransfer} dataTransfer
         * @returns {boolean}
         */
        hasFileType(dataTransfer) {
            return dataTransferReader.hasType(dataTransfer, 'Files');
        },

        /**
         * @param {DataTransferItem} item
         * @returns {FileEntry|DirectoryEntry|null}
         */
        getEntry(item) {
            let entry = null;

            if (item.getAsEntry) {
                entry = item.getAsEntry();
            } else if (item.webkitGetAsEntry) {
                entry = item.webkitGetAsEntry();
            }

            return entry;
        },

        /**
         * @param {DataTransfer} dataTransfer
         * @returns {Array.<FileEntry|DirectoryEntry>}
         */
        getEntries(dataTransfer) {
            // @type {DataTransferItemList}
            const items = dataTransfer.items;
            const entries = [];

            if (items) {
                for (let i = 0, count = items.length; i < count; i++) {
                    // @type {DataTransferItem}
                    const item = items[i];

                    if (item && item.kind === 'file') {
                        // @type {FileEntry|DirectoryEntry}
                        const entry = dataTransferReader.getEntry(item);

                        if (entry && (entry.isFile || entry.isDirectory)) {
                            entries.push(entry);
                        }
                    }
                }
            }

            return entries;
        },

        /**
         * @param {DataTransfer} dataTransfer
         * @returns {Array.<File>}
         */
        getFiles(dataTransfer) {
            // @type {FileList}
            const files = dataTransfer.files;
            const result = [];

            if (files) {
                for (let i = 0, count = files.length; i < count; i++) {
                    // @type {File}
                    const file = files[i];

                    if (file) {
                        result.push(file);
                    }
                }
            }

            return result;
        },
    };

    module.exports = dataTransferReader;
});
